import i18n from "./i18n";
import i18next from 'i18next';

/**
 *  PLC情報更新周期 ミリ秒
 */
export const PLC_STATUS_OBSERVE_SPAN = 10000;
/**
 *  Colud情報更新周期 ミリ秒
 */
export const CLOUD_STATUS_OBSERVE_SPAN = 10000;

/**
 *  IoT機器一覧更新周期 ミリ秒
 */
export const IOT_MACHINE_STATUS_OBSERVE_SPAN = 10 * 1000;

/**
 *  コナンエアーPLCNO最大値
 */
export const CONAN_AIR_PLCNO_MAX = 400;
/**
 *  コナンエアーPLCNO最小値
 */
export const CONAN_AIR_PLCNO_MIN = 301;

/**
 * 部分放電PLCNo
 */
export const PARTIAL_DISCHARGE_PLCNO = 255;

/**
 * 移動平均法(MCLC_TYP_ID)
 */
export const MOVING_AVERAGE_METHOD = 16;

/**
 * FFT比較横軸最大値　クラウド版
 */
export const FFT_MAX_VALUE_CLUDO = 5000;
/**
 * FFT比較横軸最大値　オンプレ版
 */
export const FFT_MAX_VALUE_ONPRE = 6250;

/* グラフ背景　黒テーマ */
export const GraphThemeDark = {
  BACK_COLOR: '#000000',
  MEMORY_FONT_COLOR: '#f0f8ff',
  UNIT_COLOR: '#f0f8ff',
  GRIDCOLOR: '#ccc',
}
/* グラフ背景　白テーマ */
export const GraphThemeLight = {
  BACK_COLOR: "white",
  MEMORY_FONT_COLOR: '#000000',
  UNIT_COLOR: '#000000',
  GRID_COLOR: 'black',
}

/* 軽故障ラインカラー */
export const LIGHT_FAULT_LINE_COLOR = 'orange';
/* 重故障ラインカラー*/
export const SERIOUS_FAULT_LINE_COLOR = 'red';


/**
 *  項目名称の列挙体
 */
export const NameItemKind = {
  /* 負荷側*/
  LOADSIDE: 1,
  /* 反負荷側*/
  ANTI_LOADSIDE: 2,
  /* R相*/
  R: 3,
  /* S相*/
  S: 4,
  /* T相*/
  T: 5,
  /*フレーム*/
  FLAME: 18,
} as const;
export type NameItemKind = typeof NameItemKind[keyof typeof NameItemKind];


/**
 *  診断タイプの列挙体
 */
export const JdgTypKind = {
  /* 生波形を表します*/
  RAW: 2,
  /* 可視化処理を表します*/
  KASHIKA: 3,
  /*FFT を表します*/
  FFT: 4,
  /* FFT(ENV) を表します*/
  FFT_ENV: 5,
  /* 差分 dB を表します*/
  DBD: 6,
  /* 変位 FFT を表します*/
  DSP_FFT: 7,
  /* 速度 FFT を表します*/
  SPD_FFT: 8,
  /* 移動平均を表します */
  MOVE_AVE: 9,
} as const;
export type JdgTypKind = typeof JdgTypKind[keyof typeof JdgTypKind];

/**
 * 演算Noの列挙体
 */
export const CcTypKind = {
  /* 最大値を表します */
  MAX: 1,
  /* 実効値を表します */
  RUN_VALUE: 2,
  /* OA値を表します */
  OA_VALUE: 4,
  /* 速度を表します */
  SPD: 5,
  /* 変位を表します */
  DSP: 6,
  /* dB差分値を表します */
  DBD: 7,
  /* PD強度を表します */
  PD_INTENSITY: 10,
  /* 移動平均を表します */
  MOVE_AVERAGE: 13,
  /** 部分放電　最大値 */
  PD_TYP_NO_CLC_MAXVALUE: 97,
  /**部分放電　Pd強度 */
  PD_TYP_NO_CLC_PDVALUE: 98,

} as const;
export type CcTypKind = typeof CcTypKind[keyof typeof CcTypKind];

/**
 *  低速 / 高速区分
 */
export const SpeedKind = {
  /* 低速*/
  SPEED_KIND_LOW: 1,
  /* 高速*/
  SPEED_KIND_HIGHT: 2,
  /*EMC-B*/
  SPEED_KIND_EMCB: 3,
  /* 計算タグ*/
  SPEED_KIND_CALC: 4,
  /* 計算タグ*/
  SPEED_KIND_IotBox: 5,
  /* コナンエア*/
  SPEED_CONAN: 6,
  /**部分放電 */
  SPEED_PARTIALDISCHARGE: 7,
} as const;
export type SpeedKind = typeof SpeedKind[keyof typeof SpeedKind];

/**
計測種別 (低速) の列挙体
*/
export const MeasureLowKind = {
  /* 不明な識別子*/
  NONE: 0,
  /* 電圧*/
  VOLTAGE: 1,
  /* 電流*/
  CURRENT: 2,
  /* 温度*/
  TEMPERATURE: 3,

} as const;
export type MeasureLowKind = typeof MeasureLowKind[keyof typeof MeasureLowKind];

/**
計測種別 (高速) の列挙体
*/
export const MeasureHighKind = {
  /* 不明な識別子*/
  NONE: 0,
  /* 振動 (加速度) */
  VIBRATION: 1,
  /* 線電流 R 相*/
  R_CURRENT: 2,
  /* 線電流 S 相*/
  S_CURRENT: 3,
  /* 線電流 T 相*/
  T_CURRENT: 4,
  /* 零相電流 (収集) */
  ZERO_CURRENT: 5,
  /* 温度*/
  TEMPERATURE_IOT: 6,
  /* 振動 (速度) */
  VIBRATION_SPD: 1001,
  /* 振動 (変位)*/
  VIBRATION_DSP: 1002,

} as const;

export type MeasureHighKind = typeof MeasureHighKind[keyof typeof MeasureHighKind];

/**
計測種別 (計算タグ) の列挙体
*/
export const MeasureCalcKind = {
  /* 不明な識別子*/
  NONE: 0,
  /* 零相電流 (計算) を表します */
  ZERO_CURRENT: 1,
  /* 正相電流 (計算) を表します*/
  SEI_CURRENT: 2,
  /* 逆相電流 (計算) を表します*/
  GYAKU_CURRENT: 3,

} as const;

export type MeasureCalcKind = typeof MeasureCalcKind[keyof typeof MeasureCalcKind];
/**
計測種別 コナンエアの列挙体
*/
export const MeasureConanKind = {
  /* 不明な識別子*/
  NONE: 0,
  /* 速度：X軸 */
  SOKUDO_X: 8,
  /* 速度：Y軸*/
  SOKUDO_Y: 9,
  /* 速度：Z軸*/
  SOKUDO_Z: 10,
  /* 速度：3D*/
  SOKUDO_3D: 11,
  /* 振動（速度）：X軸(FFT)*/
  SOKUDO_FFT_X: 20,
  /* 振動（速度）：Y軸(FFT)*/
  SOKUDO_FFT_Y: 21,
  /* 振動（速度）：Z軸(FFT)*/
  SOKUDO_FFT_Z: 22,
  /* 振動（速度）：3D(FFT)*/
  SOKUDO_FFT_3D: 23,

} as const;

export type MeasureConanKind = typeof MeasureConanKind[keyof typeof MeasureConanKind];

/**
計算方法 の列挙体
*/
export const MeasureClcType = {
  /*最大値を表します。*/
  eMax: 1,
  /*実効値を表します。*/
  eRms: 2,
  /*瞬時値を表します。*/
  eMon: 3,
  /*OA 値を表します。*/
  eOav: 4,
  /*速度値を表します。*/
  eSpd: 5,
  /*変位値を表します。*/
  eDsp: 6,
  /*dB 差分を表します。*/
  eDbd: 7,
  /*回転周波数を表します。*/
  eFrq: 8,
  /*平均値を表します。*/
  eAvg: 9,
  /*PD 強度を表します。*/
  ePdm: 98,
  /*特徴値を表します。*/
  eChr: 99,
} as const;

export type MeasureClcType = typeof MeasureClcType[keyof typeof MeasureClcType];

/**
 * 特徴値を多言語化します
 * @param clc
 * @param clcName デフォルト文字
 * @param translation useTranslation関数
 * @returns
 */
export const GetMeasureClcName = (clc: number, clcName: string, translation: any): string => {
  if (clc === MeasureClcType.eChr) {
    return i18next.t('Constant.特徴値', '特徴値');
  }
  return clcName;
};


/**
異常種別 の列挙体
*/
export const AlmTypKind = {
  /*軸受特徴周波数 (内輪) を表します。*/
  eChr1: 1,
  /*軸受特徴周波数 (外輪) を表します。*/
  eChr2: 2,
  /*軸受特徴周波数 (転動体) を表します。*/
  eChr3: 3,
  /*軸受特徴周波数 (保持器) を表します。*/
  eChr4: 4,
  /*特徴周波数設定 (特徴 No.1) を表します。*/
  eChr5: 5,
  /*特徴周波数設定 (特徴 No.2) を表します。*/
  eChr6: 6,
  /*特徴周波数設定 (特徴 No.3) を表します。*/
  eChr7: 7,
  /*特徴周波数設定 (特徴 No.4) を表します。*/
  eChr8: 8,
  /*電流側帯波周波数 (－側) を表します。*/
  eDbdMinus: 9,
  /*電流側帯波周波数 (＋側) を表します。*/
  eDbdPlus: 10,
  /*生波形 最大値を表します。*/
  eRawMax: 11,
  /*生波形 実効値を表します。*/
  eRawRms: 12,
  /*生波形 OA 値を表します。*/
  eRawOav: 13,
  /*生波形 速度値を表します。*/
  eRawSpd: 14,
  /*生波形 変位値を表します。*/
  eRawDsp: 15,
  /*可視化処理 最大値を表します。*/
  eKashikaMax: 16,
  /*可視化処理 実効値を表します。*/
  eKashikaRms: 17,
  /*可視化処理を表します。*/
  eKashikaShori: 18,
  /*回転子特徴周波数を表します。*/
  eKaitenChr: 19,
  /*FFT 変位周波数設定 (No.1) を表します。*/
  eFftDsp1: 20,
  /*FFT 変位周波数設定 (No.2) を表します。*/
  eFftDsp2: 21,
  /*FFT 変位周波数設定 (No.3) を表します。*/
  eFftDsp3: 22,
  /*FFT 変位周波数設定 (No.4) を表します。*/
  eFftDsp4: 23,
  /*FFT 速度周波数設定 (No.1) を表します。*/
  eFftSpd1: 24,
  /*FFT 速度周波数設定 (No.2) を表します。*/
  eFftSpd2: 25,
  /*FFT 速度周波数設定 (No.3) を表します。*/
  eFftSpd3: 26,
  /*FFT 速度周波数設定 (No.4) を表します。*/
  eFftSpd4: 27,
  /**軸受特徴周波数（内輪）：3D（負荷側） */
  eConanfft3dSpd1_loadside: 41,
  /**軸受特徴周波数（保持器）：3D（負荷側） */
  eConanfft3dSpd4_loadside: 44,
  /**軸受特徴周波数（内輪）：3D（反負荷側） */
  eConanfft3dSpd1_aloadside: 57,
  /**軸受特徴周波数（保持器）：3D（反負荷側） */
  eConanfft3dSpd4_aloadside: 60,
} as const;

export type AlmTypKind = typeof AlmTypKind[keyof typeof AlmTypKind];


/**
 * IoTBox機器一覧　収集結果種別 の列挙体
 */
export const CollectionStatsuType = {
  /* 収集中*/
  COLLECTING: 0,
  /* 収集完了*/
  END: 1,
  /* 収集失敗*/
  ERROR: 2,
} as const;
export type CollectionStatsuType = typeof CollectionStatsuType[keyof typeof CollectionStatsuType];

/**
 * 学習状況 の列挙体
 */
export const LearnStatType = {
  /* 学習前*/
  BEFORE_LEARNING: 0,
  /* 学習中 */
  LEARNING: 1,
  /* 学習後(ばらつき有)*/
  AFTER_LEARNING_VARIATION: 2,
  /* 学習後(ばらつき無)*/
  AFTER_LEARNING_NO_VARIATION: 3,
  /** 使用不可 */
  UNUSABLE: -1,
} as const;
export type LearnStatType = typeof LearnStatType[keyof typeof LearnStatType];

//=============================振動　速度、変位対応
/**
 * 主に、グループ設定で振動の特殊データだった場合
 * 特殊な番号のKINDNOへ変換する
 * @param kindNo
 * @returns
 */
export const GetVibrationSpecialNo = (kindNo: number): string => {
  if (kindNo === 1) {
    return String(MeasureHighKind.VIBRATION_SPD);
  }
  if (kindNo === 2) {
    return String(MeasureHighKind.VIBRATION_DSP);
  }
  return "0";
};
/**
 * 計測種別で単位を返します。
 * @param kindNo 計測種別
 * @param unit 単位
 * @returns
 */
export const GetVibrationSpecialNoUnit = (kindNo: number, unit: string): string => {
  switch (kindNo) {
    case MeasureHighKind.VIBRATION_SPD:
      // 振動（速度）
      return 'mm/s';
    case MeasureHighKind.VIBRATION_DSP:
      // 振動（変位）
      return 'µm';
  }
  return unit;
};

/**
 * 計測種別の特殊種別の計測種別名を返す。
 * @param kindNo 計測種別
 * @returns
 */
export const GetVibrationSpecialString = (kindNo: number, translation: any): string => {
  switch (kindNo) {
    case MeasureHighKind.VIBRATION_SPD:
      return i18next.t('Constant.振動(速度)', '振動(速度)');
    case MeasureHighKind.VIBRATION_DSP:
      return i18next.t('Constant.振動(変位)', '振動(変位)');
  }
  return "";
};

/**
 * 計測種別の列挙体
 */
export const DefaultKindNo = {
  /* デフォルト */
  NONE: 0,
  /* 振動 (速度) */
  VIBRATION_SPD: 1,
  /* 振動 (変位) */
  VIBRATION_DSP: 2,
} as const;
export type DefaultKindNo = typeof DefaultKindNo[keyof typeof DefaultKindNo];

/**
 * 計測種別の 振動 (速度)、振動 (変位) 計測種別名を返す。
 * @param kindNo 計測種別
 * @returns
 */
export const GetVibrationSpecialStringByKindNo = (kindNo: number, translation: any): string => {
  switch (kindNo) {
    case DefaultKindNo.VIBRATION_SPD:
      return i18next.t('Constant.振動(速度)', '振動(速度)');
    case DefaultKindNo.VIBRATION_DSP:
      return i18next.t('Constant.振動(変位)', '振動(変位)');
  }
  return "";
};
//=============================
